import React from 'react';

import { Icon as ChakraIcon } from '@chakra-ui/react';

import { IconProps } from '../../icon/types';

export const XxIcon = (props: IconProps) => (
  <ChakraIcon
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 640 480"
    {...props}
  >
    <path
      fill="#fff"
      fillRule="evenodd"
      stroke="#adb5bd"
      strokeWidth={1.1}
      d="M.5.5h638.9v478.9H.5z"
    />
    <path
      fill="none"
      stroke="#adb5bd"
      strokeWidth={1.1}
      d="m.5.5 639 479m0-479-639 479"
    />
  </ChakraIcon>
);
